import {useLightbox, useLightboxActionsFactory} from 'platform/lightbox';

import {isNil, sortBy} from 'ramda';

import {useGetPromoPhotoForVehicleQuery} from '@dms/api/core';
import {VehiclePromoPhotoResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {useVehicleCoverPhoto} from './useVehicleCoverPhoto';

export const useVehicleHeaderImage = (vehicleId: string | Nullish) => {
  const {photos, coverPhoto} = useVehicleCoverPhoto(vehicleId);

  const {data: vehiclePromoPhotos} = useGetPromoPhotoForVehicleQuery(
    {
      vehicleId: vehicleId ?? '',
    },
    {
      skip: isNil(vehicleId),
    }
  );

  const [lightboxControls, {onOpen}] = useLightbox('vehicleHeader');
  const lightboxActionsFactory = useLightboxActionsFactory();

  const sortedPhotos = sortBy(
    (item: VehiclePromoPhotoResponseBody) => item.position,
    vehiclePromoPhotos ?? []
  );

  const allPhotos = [...photos, ...sortedPhotos];

  const vehicleImages = lightboxActionsFactory.addFullActions(
    allPhotos.map((image) => ({
      id: image.id,
      url: image.url.replace('resize', 'get'),
      resizeUrl: image.url,
      name: image.fileId,
    }))
  );

  const onCoverPhotoClick = () => {
    const index = vehicleImages?.findIndex((slide) => slide.name === coverPhoto?.fileId);
    onOpen(index ?? 0);
  };

  return [lightboxControls, coverPhoto?.url, onCoverPhotoClick, vehicleImages] as const;
};
